export const NAME = 'centerUsers';



// WEBPACK FOOTER //
// ./src/modules/centerUsers/constants.js